import { render } from "./AppClientDetailWindow.vue?vue&type=template&id=2ddbc4ba&scoped=true"
import script from "./AppClientDetailWindow.vue?vue&type=script&lang=js"
export * from "./AppClientDetailWindow.vue?vue&type=script&lang=js"

import "./AppClientDetailWindow.vue?vue&type=style&index=0&id=2ddbc4ba&scoped=true&lang=css"
import "./AppClientDetailWindow.vue?vue&type=style&index=1&id=2ddbc4ba&scoped=true&lang=css"
import "./AppClientDetailWindow.vue?vue&type=style&index=2&id=2ddbc4ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddbc4ba"]])

export default __exports__